import interfaceAjax from '@/libs/InterfaceAjax';

export default {
    instrumentList(params,data) {
        return interfaceAjax({
            url: '/admin/instrument/list',
            params,
            data
        });
    },
    instrumentAll(data) {
        return interfaceAjax({
            url: '/admin/instrument/all',
            data
        });
    },
    instrumentAdd(data) {
        return interfaceAjax({
            url: '/admin/instrument/add',
            data
        });
    },
    instrumentUpdate(data) {
        return interfaceAjax({
            url: '/admin/instrument/update',
            data
        });
    },
    instrumentDelete(id) {
        return interfaceAjax({
            url: '/admin/instrument/delete',
            data:{id}
        });
    },
    appointmentAllot(data) {
        return interfaceAjax({
            url: '/admin/appointment/allot',
            data
        });
    },
    appointmentCancel(id) {
        return interfaceAjax({
            url: '/admin/appointment/cancel',
            data:{id}
        });
    },
    examAll(data) {
        return interfaceAjax({
            url: '/admin/user/examAll',
            data
        });
    },
    applytList(params,data) {
        return interfaceAjax({
            url: '/admin/examApply/list',
            params,
            data
        });
    },
    applytCancel(id) {
        return interfaceAjax({
            url: '/admin/examApply/cancel',
            data:{id}
        });
    },
    applytDetail(id) {
        return interfaceAjax({
            url: '/admin/examApply/detail',
            data:{id}
        });
    },
    testerList(departmentId) {
        return interfaceAjax({
            url: '/admin/report/testerList',
            data: {
                department:{
                    id:departmentId
                }
            }
        });
    },
    updateShowSeal(id, showSeal) {
        return interfaceAjax({
            url: '/admin/report/updateShowSeal',
            data: {id, showSeal}
        });
    },
    updateSign(data) {
        return interfaceAjax({
            url: '/admin/report/updateSign',
            data
        });
    }
}
